import { renderRichText, unescapeHtmlEntities } from '@/utils/stringUtils';

export interface AnalysisContent {
  title?: string;
  summary: string;
  insights?: string[];
}

interface AnalysesProps {
  content: AnalysisContent;
}

export const Analysis = (props: AnalysesProps) => {
  const { content } = props;

  const rawTitle = (content.title || '').trim();
  const rawSummary = (content.summary || '').trim();
  const rawInsights = content.insights || [];

  const title = unescapeHtmlEntities(rawTitle);
  const summary = unescapeHtmlEntities(rawSummary);
  const insights = rawInsights
    ? rawInsights.map((i: string) => renderRichText(i)).filter(Boolean)
    : [];

  let header = null;
  if (title) {
    header = (
      <h2 className='text-base md:text-lg m-0 p-0 leading-none'>{title}</h2>
    );
  }

  return (
    <div className='flex flex-col gap-2'>
      {header}
      <hr className='mt-4 border-t border-gray-300 dark:border-gray-600' />
      <div className='prose whitespace-pre-line'>
        {summary && <p className='m-0'>{renderRichText(summary)}</p>}
        {insights.length > 0 && (
          <ul className='list-disc/ml-4 mt-2 space-y-1'>
            {insights.map((insight, idx) => (
              <li key={idx}>{insight}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
